class MFRMixAndMatch {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            mobileWrapper: ".mix-and-match__mobile-bundler",
            bundler: ".mix-and-match__bundler"
        }
        this.elementsOnBottom = [
          "#admin-bar-iframe",
          ".cc-revoke.cc-bottom.cc-left",
          ".smile-launcher-frame-container",
          ".smile-improved-mobile-launcher",
          "#smile-ui-lite-launcher-frame-container",
          "#gorgias-chat-container #chat-window",
          "#gorgias-chat-container #chat-button",
        ];
        this.init();
    }

    init() {
        this.$mobileWrapper = this.$element.find( this.selectors.mobileWrapper );
        this.initBundler();
    }

    initBundler() {
        $( "body" ).append( this.$mobileWrapper );
        $( "body" ).find( this.selectors.mobileWrapper )
        gsap.set( $( "body" ).find( this.selectors.mobileWrapper ), {
            yPercent: 100
        } );
        const scrollTrigger = ScrollTrigger.create( {
            trigger: this.$element,
            start: "top 25%",
            end: "bottom top",
            onEnter: () => this.stickyEnter(),
            onEnterBack: () => this.stickyEnter(),
            onLeave: () => this.stickyLeave(),
            onLeaveBack: () => this.stickyLeave()
        } );
    }

    stickyEnter() {
        gsap.to( $( "body" ).find( this.selectors.mobileWrapper ), {
            yPercent: 0
        } )
        this.animateElementsOnBottom(
          `${$("body").find(this.selectors.mobileWrapper).outerHeight() + 16}px`
        );
    }

    stickyLeave() {
        gsap.to( $( "body" ).find( this.selectors.mobileWrapper ), {
            yPercent: 100
        } )

        this.animateElementsOnBottom(16);
    }
    animateElementsOnBottom( y ) {
        if( $( window ).width() >= 1024 ) return;
        $.each( this.elementsOnBottom, ( i, e ) => {
            if( !$( e ).length ) return;
            gsap.set( e, {
                transition: "unset",
                opacity: 1
            } );
            gsap.to( e, {
                bottom: y
            })
        } );
    }
}